import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../RoutingAuth/auth.service';
import { BaseBusyableComponent } from '../../../Services/BaseBusyableComponent';

@Component({
     selector: 'actConfirm',
     templateUrl: './actConfirm.html',
     styleUrls: [],
     
})
export class actConfirmComponent extends BaseBusyableComponent implements OnInit { 


     constructor(
          private authService: AuthService,
          private route: ActivatedRoute, 
     ) {
          super();
     }    
  
     title = "Account Confirmation";
    
    login() {     
      
      this.authService.login();
    }   

     ngOnInit() {
          
        
    }
}


 